import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SupportsTable } from '../supports-table/supports-table.model';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
  selector: 'operation-current-allocation-form',
  templateUrl: './operation-current-allocation-form.component.html',
  styleUrls: ['./operation-current-allocation-form.component.scss'],
  standalone: false,
})
export class OperationCurrentAllocationFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  supportsTable: SupportsTable = {
    title: 'Répartition actuelle du contrat',
    removable: false,
    totalLabel: 'Valorisation totale',
    emptyLabel: 'Aucun support sur ce contrat.',
    columns: [
      { label: 'Support', type: 'support' },
      {
        label: 'Valorisation',
        type: 'amount',
        valueName: 'amount',
        unit: '€',
        digits: '1.2-2',
        total: true,
      },
    ],
  };

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  totalAmount() {
    return (
      this.products.get(`${0}`).get('parameters').get('totalAmount').value || 0
    );
  }
}
